import { c as _c } from "react/compiler-runtime";
import { AllowlistDescription } from "@/components/allowlist-tool/allowlist-tool.types";
export default function EmmaListSearchItem(t0) {
  const $ = _c(18);
  const {
    item,
    selectedId,
    onSelect
  } = t0;
  const isSelected = selectedId === item.id;
  let t1;
  if ($[0] !== item || $[1] !== onSelect) {
    t1 = () => onSelect(item);
    $[0] = item;
    $[1] = onSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== item.name) {
    t2 = <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-white tw-truncate tw-whitespace-nowrap">{item.name}</p>;
    $[3] = item.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== item.description) {
    t3 = <p className="tw-mb-0 tw-text-xs tw-font-medium tw-text-iron-400 tw-truncate tw-whitespace-nowrap">{item.description}</p>;
    $[5] = item.description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-inline-flex tw-space-x-2 tw-items-center"><div>{t2}{t3}</div></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isSelected) {
    t5 = isSelected && <svg className="tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[10] = isSelected;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="tw-w-full tw-truncate tw-inline-flex tw-justify-between tw-items-center">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t6) {
    t7 = <li className="tw-h-full"><button type="button" onClick={t1} className="hover:tw-bg-iron-700 tw-py-2 tw-w-full tw-h-full tw-bg-transparent tw-border-none tw-text-left tw-flex tw-items-center tw-justify-between tw-text-white tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-2 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out">{t6}</button></li>;
    $[15] = t1;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}